import {
  CreateMessageRequestDto,
  MessageSuggestionsDto,
  MessageTemplateCategoryDto,
  MustacheTemplateVariablesDto,
  MessageWithFeedItemDto,
  MessageDto,
  UpdateMessageRequestDto,
} from '@act/shared/data-transfer-objects';
import { EndpointDefinition } from '../utils/endpointDefinition';

export const messagesRequests = {
  getMessageTemplates: EndpointDefinition.get<
    MessageTemplateCategoryDto[],
    { userId: string }
  >({
    name: 'getMessageTemplates',
    route: '/chat/messages/templates',
  }),

  getTemplateVariables: EndpointDefinition.get<
    MustacheTemplateVariablesDto,
    { userId: string }
  >({
    name: 'getTemplateVariables',
    route: '/chat/messages/template-variables',
  }),

  createMessage: EndpointDefinition.post<
    MessageWithFeedItemDto,
    CreateMessageRequestDto,
    null
  >({
    name: 'createMessage',
    route: '/chat/messages',
  }),

  updateMessage: EndpointDefinition.patch<
    MessageDto,
    UpdateMessageRequestDto,
    { messageId: number }
  >({
    name: 'updateMessage',
    route: '/chat/messages/:messageId',
  }),

  updateMessageNoFollowUpNeeded: EndpointDefinition.post<
    MessageWithFeedItemDto,
    { noFollowUpNeeded: boolean },
    { messageId: number }
  >({
    name: 'updateMessageNoFollowUpNeeded',
    route: '/chat/messages/:messageId/no_follow_up_needed',
  }),

  getMessageSuggestions: EndpointDefinition.get<
    MessageSuggestionsDto,
    { memberId: string }
  >({
    name: 'getMessageSuggestions',
    route: '/chat/messages/suggestions',
  }),

  getScheduledMessagesByMember: EndpointDefinition.get<
    MessageDto[],
    { memberId: string }
  >({
    name: 'getScheduledMessagesByMember',
    route: '/chat/messages/scheduled',
  }),

  deleteMessage: EndpointDefinition.delete<null, { messageId: number }>({
    name: 'deleteMessage',
    route: '/chat/messages/:messageId',
  }),

  sendScheduledMessage: EndpointDefinition.post<
    MessageWithFeedItemDto,
    null,
    { messageId: number }
  >({
    name: 'sendScheduledMessage',
    route: '/chat/messages/:messageId/send',
  }),

  getSchedulingStatus: EndpointDefinition.get<
    {
      scheduledCount: number;
      scheduledLimit: number;
      sendingCount: number;
      sendingLimit: number;
      canSchedule: boolean;
      canSend: boolean;
    },
    { date: string }
  >({
    name: 'getSchedulingStatus',
    route: '/chat/messages/scheduling-status',
  }),
};
